/**
 * Created by Omar Alejandro Leonor Avalos on 2017-06-05.
 * Reducer for the container.
 */
import { NOTIFY } from './types';
import { updateState } from '../../common/helpers';

const INITIAL_STATE = {
    password: ''
};

export default (state = INITIAL_STATE, { type, payload }) => {
    switch (type) {
        case NOTIFY:
            return updateState(payload, state);
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./containers/playground/reducer.js